 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({}[chunkId]||chunkId) + "." + {"chunk-021d5ecc":"ab306d35","chunk-088ff9c4":"3d661beb","chunk-0d13587f":"05bbb7b1","chunk-0f67ed0e":"06bd3f3b","chunk-15321b3d":"515b4ea7","chunk-2aebd3fb":"c7d13928","chunk-6686dace":"038ea63e","chunk-6af1bfdd":"2975e9be","chunk-73dee866":"2b46e30e","chunk-58e73ef6":"8c164967","chunk-97006a5a":"f06a4f6a","chunk-1b973719":"bd69b22a","chunk-222d5524":"db917e7b","chunk-244bd364":"9f9f5ca4","chunk-26b7f32c":"73a55c38","chunk-ae25ddb0":"79e51584","chunk-2d0c0c33":"950c2a89","chunk-2d21a9a9":"c47b9e5b","chunk-2d21f29d":"13aa17b2","chunk-2d22ce37":"c071a02e","chunk-3f954034":"57a8b845","chunk-4a38101e":"728799c6","chunk-4fb06232":"fa7f9a87","chunk-50274af8":"2f4e1ba8","chunk-57e2746d":"a9a88916","chunk-609d4a8c":"3f1c7c24","chunk-93275ae4":"452185db","chunk-6d0f6c29":"982fbadd","chunk-70471c04":"9652e730","chunk-71db9392":"e23bb640","chunk-71e7f010":"93e24fc4","chunk-7dad454a":"bd7c878d","chunk-839e8d0a":"ad35e88d","chunk-bfb39cd6":"6428063d","chunk-d86506f6":"1463f941","chunk-e9918708":"2f356f94","chunk-ed75e97c":"cd8382e6","chunk-2d216214":"1f54003d","chunk-b7528f5c":"260a3148"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"chunk-021d5ecc":1,"chunk-088ff9c4":1,"chunk-0d13587f":1,"chunk-15321b3d":1,"chunk-6686dace":1,"chunk-6af1bfdd":1,"chunk-73dee866":1,"chunk-58e73ef6":1,"chunk-97006a5a":1,"chunk-1b973719":1,"chunk-222d5524":1,"chunk-244bd364":1,"chunk-ae25ddb0":1,"chunk-3f954034":1,"chunk-4a38101e":1,"chunk-4fb06232":1,"chunk-50274af8":1,"chunk-57e2746d":1,"chunk-609d4a8c":1,"chunk-93275ae4":1,"chunk-6d0f6c29":1,"chunk-70471c04":1,"chunk-71db9392":1,"chunk-71e7f010":1,"chunk-7dad454a":1,"chunk-839e8d0a":1,"chunk-bfb39cd6":1,"chunk-d86506f6":1,"chunk-e9918708":1,"chunk-ed75e97c":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({}[chunkId]||chunkId) + "." + {"chunk-021d5ecc":"819dc80c","chunk-088ff9c4":"dcee3812","chunk-0d13587f":"bbc1b58c","chunk-0f67ed0e":"31d6cfe0","chunk-15321b3d":"eba838c1","chunk-2aebd3fb":"31d6cfe0","chunk-6686dace":"bee9ac7c","chunk-6af1bfdd":"6eea20eb","chunk-73dee866":"eaa10626","chunk-58e73ef6":"e7ca2ece","chunk-97006a5a":"b7f2023c","chunk-1b973719":"63f775ad","chunk-222d5524":"797087d6","chunk-244bd364":"d8ce8af7","chunk-26b7f32c":"31d6cfe0","chunk-ae25ddb0":"7fb6ee50","chunk-2d0c0c33":"31d6cfe0","chunk-2d21a9a9":"31d6cfe0","chunk-2d21f29d":"31d6cfe0","chunk-2d22ce37":"31d6cfe0","chunk-3f954034":"f996b811","chunk-4a38101e":"dc4e5d6d","chunk-4fb06232":"c6b4ecff","chunk-50274af8":"95387096","chunk-57e2746d":"7cc7a79e","chunk-609d4a8c":"9b412eb6","chunk-93275ae4":"72cebccf","chunk-6d0f6c29":"6b0686f5","chunk-70471c04":"4144b5da","chunk-71db9392":"d1bdea88","chunk-71e7f010":"659c58ee","chunk-7dad454a":"5b4ee790","chunk-839e8d0a":"3fd2e09c","chunk-bfb39cd6":"5a42745a","chunk-d86506f6":"dcca3df0","chunk-e9918708":"476d3d6a","chunk-ed75e97c":"0e6e8c4d","chunk-2d216214":"31d6cfe0","chunk-b7528f5c":"31d6cfe0"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "https://static.www.yuugeai.com/static/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
